export default __webpack_public_path__ + "static/media/listImg.ad4cdc97.svg";